import { HistoryService, HttpResponse, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { TimelineParams } from './electronic-service-timeline-params';
import { TimelineEvent } from '@philips-internal/oswald-ui-components';
import { Endpoint } from '../../../../constants/endpoints';

export default class TimelineService {
  public static getDataTimeLine(timeLineParams: TimelineParams): Promise<TimelineEvent[]> {
    const { patientId, encounterId } = HistoryService.getCurrentRouteParams();
    const defaultHoursQuantity = 72;
    const body = {
      additionalHoursQuantity: timeLineParams.additionalHoursQuantity || defaultHoursQuantity,
      encounterNumber: timeLineParams.encounterNumber,
      modelSequenceNumber: timeLineParams.modelSequenceNumber,
      performedItems: timeLineParams.performedItems,
      prescriptionDate: timeLineParams.prescriptionDate,
      prescriptionHourQuantity: timeLineParams.prescriptionHourQuantity,
      previousHoursQuantity: timeLineParams.previousHoursQuantity,
      userSectorIntervalType: timeLineParams.userSectorIntervalType,
      userSectorProcedureType: timeLineParams.userSectorIntervalType,
    }

    return Promise.resolve(
      HttpService.post(
        Endpoint.EMAR_GET_TIMELINE,
        {
          encounterNumber: encounterId,
          patientCode: patientId,
        }, { body }
      ).then(response => {
        return response.body as TimelineEvent[];
      }));
  }

  public static getSecurityAlertList(patientId: string, encounterId: string): Promise<HttpResponse<unknown>> {
    const adepNumberFunction = 1113;

    return HttpService.get(Endpoint.EMAR_SECURITY_ALERT_LIST, {
      alertPersonCode: patientId,
      encounterNumber: encounterId,
      functionCode: adepNumberFunction
    })
  }

  public static listPrescriptionSteps(prescriptionNumber: string, sequenceNumber: string): Promise<HttpResponse<unknown>> {
    return HttpService.get(Endpoint.LIST_PRESCRIPTION_STEPS, {
      prescriptionNumber,
      sequenceNumber
    })
  }
}
